import type WeatherLocationId from 'owa-service/lib/contract/WeatherLocationId';
import TemperatureUnit from 'owa-service/lib/contract/TemperatureUnit';
import type { WeatherLocation as GqlWeatherLocation } from 'owa-graph-schema';
import { getApolloClient } from 'owa-apollo';
import {
    WeatherForecastQueryVariables,
    WeatherForecastDocument,
    WeatherForecastQuery,
} from '../graphql/__generated__/weatherForecastQuery.interface';

export type WeatherForecastResultType = WeatherForecastQuery['weatherForecast'];

/**
 * Executes getWeatherForecastOperation
 * @param {TemperatureUnit} unit temperature units
 * @param {WeatherLocationId[]} weatherLocationIds list of weather location ids
 * @returns GetWeatherForecastResponse
 */
export default async function getWeatherService(
    unit: TemperatureUnit,
    weatherLocationIds: WeatherLocationId[]
): Promise<WeatherForecastResultType> {
    const gqlWeatherLocations: GqlWeatherLocation[] = weatherLocationIds.map(weatherLocationId => {
        return {
            Latitude: String(weatherLocationId?.Latitude),
            Longitude: String(weatherLocationId?.Longitude),
            Name: weatherLocationId?.Name,
            LocationId: weatherLocationId?.EntityId,
        };
    });

    const gqlTemperatureUnit = unit == TemperatureUnit.Celsius ? 'Celsius' : 'Fahrenheit';

    const weatherForecastQueryInput: WeatherForecastQueryVariables = {
        temperatureUnit: gqlTemperatureUnit,
        weatherLocations: gqlWeatherLocations,
    };

    const client = getApolloClient();
    const result = await client.query({
        variables: weatherForecastQueryInput,
        query: WeatherForecastDocument,
    });

    return result?.data?.weatherForecast;
}
